import { useFeatureFlagEnabled } from 'posthog-js/react'

/** PostHog flag that holds lesson discussions (preview, panel, bell) back until they are ready. */
export const LESSON_DISCUSSIONS_FLAG = 'lesson-discussions'

// Off until PostHog says otherwise: while flags load, or if they never load, learners keep the old card.
// `npm start` usually runs without a PostHog key, so flags never load there; local development shows the
// feature. Every built site (DEV and PROD alike) is a production build and follows the flag.
export const useLessonDiscussionsEnabled = (): boolean => {
  const enabled = useFeatureFlagEnabled(LESSON_DISCUSSIONS_FLAG) === true
  return enabled || process.env.NODE_ENV === 'development'
}
